// Five device characteristics for abuse prevention. Browsers expose no serial numbers, so these are the
// values the browser reports. Only their hashes leave the device; see the terms and privacy notice.
function gpuName(){
 try{
  const gl=document.createElement('canvas').getContext('webgl');
  if(!gl)return '';
  const info=gl.getExtension('WEBGL_debug_renderer_info');
  const name=info?gl.getParameter(info.UNMASKED_RENDERER_WEBGL):gl.getParameter(gl.RENDERER);
  gl.getExtension('WEBGL_lose_context')?.loseContext();
  return String(name||'');
 }catch{return '';}
}
async function digest(value:string){
 const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(value));
 return [...new Uint8Array(bytes)].map(b=>b.toString(16).padStart(2,'0')).join('');
}
export async function collectClientSignals(){
 const nav=navigator as any;
 const raw={cpu:String(nav.hardwareConcurrency||''),memory:String(nav.deviceMemory||''),gpu:gpuName(),screen:[screen.width,screen.height,screen.colorDepth,devicePixelRatio].join('x'),platform:String(nav.userAgentData?.platform||nav.platform||'')};
 const entries=await Promise.all(Object.entries(raw).map(async([key,value])=>[key,await digest(value)]));
 return Object.fromEntries(entries);
}
let sentFor='';
// Once per account and page load, after the app has settled.
export function sendClientSignals(userId:string,post:(body:Record<string,string>)=>Promise<unknown>){
 if(!userId||sentFor===userId||!crypto.subtle)return;
 sentFor=userId;
 const run=()=>void collectClientSignals().then(post).catch(()=>{});
 const idle=(window as any).requestIdleCallback;
 if(idle)idle(run,{timeout:10000});else setTimeout(run,3000);
}
